import { Tooltip } from '@mui/material';
import { withStyles } from '@mui/styles';
import { ITheme } from '../../../../../../theme/types';

export const HtmlTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: '#FFFFFF',
    color: '#000000',
    borderRadius: '8px',
    fontSize: '14px',
    maxWidth: '260px',
    boxShadow: '0px 0px 20px 0px grey',
    padding: '15px',
  },
  popper: {
    zIndex: 1300,
  },
}))(Tooltip);
